"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FEATURE_DEMO_STATE = {
    persona: undefined,
    usecase: 'ads',
};
exports.FEATURE_CONFIG = {
    personas: {
        adOperations: {},
        advertiser: {},
        editor: {},
        newsletterManager: {},
    },
    usecases: {
        ads: [
            {
                description: 'Newsletter Managers and Ad Operations team members can handle changes to ad blocks within emails, and lock their changes to give Editors peace of mind & ensure changes go through a process.',
                images: [
                    'https://storage.googleapis.com/img.osmosys.app/vox-media/5/2019/10/16/01/screen-shot-2019-10-15-at-9.22.36-pm.png',
                ],
                name: 'Admin-Controllable Lockable Blocks',
                personas: ['editor', 'newsletterManager', 'adOperations'],
                product: 'osmosys',
                status: 'production',
            },
            {
                description: 'Ad blocks can inform editors of whether or not a given ad is ready to send.',
                images: [
                    'https://storage.googleapis.com/img.osmosys.app/vox-media/5/2019/10/16/01/screen-shot-2019-10-15-at-9.28.51-pm.png',
                ],
                name: 'Ad blocks that communicate',
                personas: ['editor'],
                product: 'osmosys',
                status: 'draft',
            },
            {
                description: 'Orchestrate your entire ad operations from a single dashboard.',
                images: [
                    'https://storage.googleapis.com/img.stage.osmosys.app/widget-co./2/2019/10/16/08/screen-shot-2019-10-16-at-8.07.27-am.png',
                ],
                name: 'Get an overview of all ad units and creatives, across all emails',
                personas: ['adOperations', 'newsletterManager'],
                product: 'circular',
                status: 'experimental',
            },
            {
                description: 'Powerful native advertising content creation capabilities.',
                images: [
                    'https://storage.googleapis.com/img.stage.osmosys.app/widget-co./2/2019/10/16/08/screen-shot-2019-10-16-at-8.28.40-am.png',
                ],
                name: 'Visual blocks editor for ad creatives with rich text editor and WYSIWYG',
                personas: ['adOperations', 'advertiser'],
                product: 'circular',
                status: 'draft',
            },
            {
                description: 'If you want to, you will be able to send a link to advertisers that will let them submit their content.',
                images: [
                    'https://storage.googleapis.com/img.stage.osmosys.app/widget-co./2/2019/10/16/08/screen-shot-2019-10-16-at-8.34.31-am.png',
                    'https://storage.googleapis.com/img.stage.osmosys.app/widget-co./2/2019/10/16/08/screen-shot-2019-10-16-at-8.28.40-am.png',
                ],
                name: 'Give advertisers the power to produce their own creatives',
                personas: ['adOperations', 'advertiser'],
                product: 'circular',
                status: 'draft',
            },
            {
                description: 'If you want to, customize your advertising workflow to include approval from internal or external stakeholders.',
                images: [
                    'https://storage.googleapis.com/img.stage.osmosys.app/widget-co./2/2019/10/16/08/screen-shot-2019-10-16-at-8.41.22-am.png',
                ],
                name: 'Automate the ad previewing and approval process',
                personas: ['adOperations', 'advertiser', 'newsletterManager'],
                product: 'circular',
                status: 'draft',
            },
        ],
        content: [
            {
                description: 'Ad blocks can inform editors of whether or not a given ad is ready to send.',
                images: [
                    'https://storage.googleapis.com/img.osmosys.app/vox-media/5/2019/10/16/01/screen-shot-2019-10-15-at-9.28.51-pm.png',
                ],
                name: 'Warn editors before they send out blank content',
                personas: ['editor'],
                product: 'osmosys',
                status: 'draft',
            },
        ],
    },
};
//# sourceMappingURL=constants.js.map